export default __webpack_public_path__ + "static/media/30.13aa6f5d.jpg";